import { Link } from "react-router-dom";

const stats = [
  { value: "12,000+", label: "影视资源" },
  { value: "4", label: "内容大类" },
  { value: "每日", label: "持续更新" },
  { value: "高清", label: "画质保证" },
];

export default function PlatformIntro() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
      <div className="overflow-hidden rounded-lg bg-primary-700">
        <div className="grid grid-cols-1 gap-8 px-6 py-10 md:grid-cols-2 md:px-10 md:py-12">
          <div>
            <h2 className="font-heading text-2xl font-extrabold tracking-tight text-background-50 md:text-3xl">
              发现属于你的下一部好片
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-100/90 md:text-base">
              色虎视频以专业资料风格整理海量高清影视资源，按电影、电视剧、综艺、动漫四大类清晰归档，配合地区、年份、类型多维筛选，让你在几秒钟内找到想看的内容。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/category/movie"
                className="inline-flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
              >
                <i className="ri-compass-3-line text-lg" aria-hidden="true" />
                开始探索
              </Link>
              <Link
                to="/about"
                className="inline-flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
              >
                了解平台
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 self-center">
            {stats.map((item) => (
              <div
                key={item.label}
                className="rounded-lg bg-primary-600 px-4 py-5 text-center"
              >
                <p className="font-heading text-2xl font-extrabold text-background-50">{item.value}</p>
                <p className="mt-1 text-xs text-background-100/80">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}